import type {SlotGameSubController} from "@gamzix/slot_core";

//@ts-ignore
class GameSlotGameSubController extends SlotGameSubController {
    constructor(game) {
        super(game);

        this.addCustomPhases(["shakingHeapTriggerBonusGame", "flyStarsIntoHeapTriggerBonusGame", "customReplaceSymbols", "flyStarsIntroHeapBeforeBonusWin", "startCollector", "showBonusWin"], "CHECK", "checkStartBonusGame");
        this.addCustomPhases(["showBigWin"], "SHOW_WIN", "showAllWins");
        this.addCustomPhases(["showScattersWin", "flyStarsIntroHeapBeforeStartFreeSpinsGame"], "CHECK", "checkStartFreeSpinsGame");
        this.addCustomPhases(["flyStarsIntroHeap", "setDelayForShowFlyStarInFinishFreeSpinsGame"], "CHECK", "checkFinishFreeSpinsGame");

    }

}

export {GameSlotGameSubController};

Game.src.subController.GameSubController = GameSlotGameSubController;

